import { render, staticRenderFns } from "./EmailSendDialog.vue?vue&type=template&id=295cadd5&scoped=true"
import script from "./EmailSendDialog.vue?vue&type=script&lang=js"
export * from "./EmailSendDialog.vue?vue&type=script&lang=js"
import style0 from "./EmailSendDialog.vue?vue&type=style&index=0&id=295cadd5&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295cadd5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295cadd5')) {
      api.createRecord('295cadd5', component.options)
    } else {
      api.reload('295cadd5', component.options)
    }
    module.hot.accept("./EmailSendDialog.vue?vue&type=template&id=295cadd5&scoped=true", function () {
      api.rerender('295cadd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/components/EmailSendDialog.vue"
export default component.exports